export const URL = {
    CHECKOUT_BOOKING: '/booking/checkout',
    DETAIL_BOOKING: '/booking/detail'
};
